import React, { memo } from "react";
import { styled } from "@mui/material/styles";

import AuthLayout from "./AuthLayout";
import borderBack from "../../../assets/images/borderBack.png";
import AuthInput from "../../shared/authinput";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import MainButton from "../../shared/Button";
import { useNavigate } from "react-router-dom";
// import { Container } from "@mui/material";
import FormMainLayouts from "../../layouts/FormMainLayouts";

const Header = styled("div")(({ theme }) => ({ display: "flex", gap: "20px" }));
const LinkedButton = styled("button")(({ theme }) => ({
  height: "50px",
  border: "none",
  background: "transparent",
  cursor: "pointer",
}));

const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "10px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "40px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
    "& span": {
      color: "#0B0B0B !important",
      paddingLeft: "12px",
      fontWeight: 600,
    },
  },
}));

const PaymentAccount = ({ ClickHandler }) => {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    AccountName: Yup.string().required("Account name is required"),
    AccountNumber: Yup.number().required("Account number is required"),
    RoutingNumber: Yup.number().required("Routing number is required"),
  });

  return (
    <>
      {/* <Container maxWidth="lg"> */}
      <AuthLayout arrow={true}>
        <Header>
          <LinkedButton onClick={() => ClickHandler(false)}>
            <img src={borderBack} alt="Linkarrow" />
          </LinkedButton>
          <Maincontant>
            <h6>Add Payment Method</h6>
            <p>Provide your ACH details below</p>
          </Maincontant>
        </Header>
        <FormMainLayouts>
          <Formik
            initialValues={{
              AccountName: "",
              AccountNumber: "",
              RoutingNumber: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              navigate("/pending-appproval");
              // handle form submission here
              console.log("values", values);
            }}
          >
            {(formik) => (
              <Form autocomplete="off">
                <Field
                  type="text"
                  name="AccountName"
                  label="Account Name"
                  component={AuthInput}
                  placeholder="Enter account holder name"
                />
                <Field
                  type="number"
                  name="AccountNumber"
                  label="Account Number"
                  component={AuthInput}
                  placeholder="Enter your account number"
                />
                <Field
                  type="number"
                  name="RoutingNumber"
                  label="Routing Number"
                  component={AuthInput}
                  placeholder="Enter your routing number"
                />
                <MainButton type="submit" label="Add ACH" MT="110" />
              </Form>
            )}
          </Formik>
        </FormMainLayouts>
      </AuthLayout>
      {/* </Container> */}
    </>
  );
};

export default memo(PaymentAccount);
